import { Interface } from '../../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * @interface StrategyInterface
 */
export default new Interface({
    checkItemDepth() {},
});
